var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeControlFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/volume-control-full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5.000000, 7.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.571,6 L1.25,6 C0.835786438,6 0.5,6.33578644 0.5,6.75 L0.5,11.25 C0.5,11.6642136 0.835786438,12 1.25,12 L5.571,12 C6.69758425,14.8846207 9.34405661,16.8959242 12.425,17.209 C12.6357871,17.2298719 12.8455868,17.1607587 13.002698,17.0186921 C13.1598092,16.8766255 13.2496206,16.6748176 13.25,16.463 L13.25,1.537 C13.25,1.32508002 13.160213,1.12308003 13.0030261,0.980944991 C12.8458392,0.83880995 12.6358577,0.76980799 12.425,0.791 C9.34405661,1.10407577 6.69758425,3.11537932 5.571,6 Z",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.463,12.55 C21.8456474,10.3852749 21.8456474,7.61472508 20.463,5.45",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.562,11.241 C18.6026001,9.95890978 18.6026001,8.12309022 17.562,6.841",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeControlFull);
export default __webpack_public_path__ + "static/media/volume-control-full.f95d683c7d606cd4196d311923a15f92.svg";
export { ForwardRef as ReactComponent };